import {inject} from '~ui/store/store';

import {PromoState, reducer} from './slice';

const KEY = 'promo';

inject(KEY, reducer);

declare global {
    interface WikiState {
        [KEY]: PromoState;
    }
}
